
const Loader = () => {

  return (
    
<div style={{
				position: "fixed",
				zIndex:1000,
				top: 0,
				left: 0,
               
				width: "100%",
				height: "100%",
				background: "transparent",
			backdropFilter:'blur(8px)',
            alignItems: 'center',
            display: "flex",
            justifyContent:'center'
  

			}}> 
<div className="boxes">
    <div className="box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
    <div className="box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
    <div className="box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
    <div className="box">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>
  
  </div>	
  );
};

export default Loader;
